import React from 'react'
import DaysCurrent from 'app/days/Current'
import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import getModelMember from 'braindamage/api/getModelMember'
import Dodone from 'models/dodone'

export default () => {
  const dodoneId = 'current'

  // TODO: Dry with dodones/Show.jsx
  const { isPending, error, data: { dodone } = {} } = useQuery({
    queryKey: ['dodone', dodoneId],
    queryFn: async () => {
      const data = await getModelMember(`/api/dodones/${dodoneId}`, Dodone);
      return data;
    }
  })

  if(isPending) return <div className="p-d"> Loading </div>;

  return <Navigate to={ `/dodones/${dodone.id}` } replace />;
}
